import { IconMap2, IconRefresh } from "@tabler/icons-react";
import UnlockOverlay from "./UnlockOverlay";
import TestPager from "./TestPager";
import CourseThumb from "./CourseThumb";
import styles from "./AiInsights.module.css";
import useSwipe from "../../../../hooks/useSwipe";
import { careerPlanUnlockPrice, testResults } from "../components/data";

export default function LearningPlanCard({
  activeIndex,
  onSelect,
  isUnlock,
  handleTalentSubscribe,
  subscribeLoading,
  data,
  setDisclaimerModal,
}) {
  const slides = Array.isArray(data)
    ? data?.flatMap((item) => item?.testResult?.skillsAnalysis || [])
    : [];

  const items = isUnlock ? slides : testResults;
  const attempt = items[activeIndex];

  const swipeHandlers = useSwipe((dir) => {
    if (!items.length) return;
    onSelect((activeIndex + dir + items.length) % items.length);
  });

  return (
    <div className={`${styles.card} ${styles.cardLearning}`}>
      <div className={styles.cardBodyFlush}>
        <div className={styles.learningCard}>
          <div className={styles.lockedWrap}>
            <div
              className={`${styles.lockedContent} ${isUnlock ? styles.lockedContentUnlocked : ""} ${subscribeLoading ? styles.unlockPulse : ""}`}
              {...swipeHandlers}
            >
              <span className={styles.learningEyebrow}>
                <IconMap2 size={14} /> Soft Life Career Learning Plan
              </span>
              {data?.length > 0 && (
                <div className={styles.learningBody}>
                  Access the blueprint you need to grow and achieve that
                  soft-life you dream about.
                </div>
              )}

              {!isUnlock && (
                <div key={activeIndex} className={styles.carouselEnter}>
                  <div className={styles.learningRole}>{attempt?.skill}</div>
                  <div className={styles.courseLabel}>Recommended Courses</div>
                  <div className={styles.courseList}>
                    {attempt?.resources?.map((c, i) => (
                      <div
                        key={c?.title}
                        className={`${styles.courseRow} ${i === 0 ? styles.courseRowFirst : ""} ${i === attempt?.resources?.length - 1 ? styles.courseRowLast : ""}`}
                      >
                        <CourseThumb />
                        <div className={styles.courseInfo}>
                          <div className={styles.courseTitle}>{c?.title}</div>
                          <div className={styles.courseDesc}>
                            {c?.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {data?.length === 0 && (
                <p className="text-base my-6 text-[#fff] text-center">
                  You have not taken the psychometric test yet
                </p>
              )}
              {isUnlock && data?.length > 0 && attempt && (
                <div key={activeIndex} className={styles.carouselEnter}>
                  <div className={styles.learningRole}>{attempt?.skill}</div>
                  <div className={styles.courseLabel}>Recommended Courses</div>
                  <div className={styles.courseList}>
                    {attempt?.resources?.map((c, i) => (
                      <div
                        key={c?.title + i}
                        className={`${styles.courseRow} ${i === 0 ? styles.courseRowFirst : ""} ${i === attempt?.resources?.length - 1 ? styles.courseRowLast : ""}`}
                        onClick={() => {
                          window.open(c?.url, "_blank");
                        }}
                      >
                        <CourseThumb />
                        <div className={styles.courseInfo}>
                          <div className={styles.courseTitle}>{c?.title}</div>
                          <div className={styles.courseDesc}>
                            {c?.description}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              {(isUnlock ? slides : testResults)?.length > 1 && (
                <TestPager
                  items={isUnlock ? slides : testResults}
                  activeIndex={activeIndex}
                  onSelect={onSelect}
                  light
                />
              )}

              <div className={styles.takeTestRow}>
                <button
                  onClick={() => {
                    setDisclaimerModal(true);
                  }}
                  className={styles.takeTestBtnLight}
                >
                  <IconRefresh size={14} />{" "}
                  {data?.length === 0 ? "Take Test" : "Take Another Test"}
                </button>
              </div>
            </div>

            <UnlockOverlay
              unlocked={isUnlock}
              price={careerPlanUnlockPrice}
              onUnlock={handleTalentSubscribe}
              disabled={subscribeLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
